import React from "react"
import styled from "styled-components"
import { Form, Checkbox } from "antd"
import { get } from "lodash"
import { getColor, colors } from "../../../../components/Color"
import { media } from "../../../../components/mediaStylesNew"
import CheckIcon from "../CheckIcon"
import ErrorIcon from "../ErrorIcon"
import Question from "../Question"

const TextIcon = styled.div`
  font-family: Recife Text, serif;
  font-weight: 700;
  font-size: 20px;
`

const CheckboxInput = styled(Checkbox)`
  max-width: 100%;
  display: flex !important;
  align-items: center;

  input {
    width: 30px !important;
    height: 30px !important;
    padding: 20px;
    padding-left: 35px !important;
    font-family: GT America, sans-serif;
    font-size: 16px;

    border: 2px solid green;
    &:active {
      background: blue;
    }
  }

  .ant-checkbox-inner,
  .ant-checkbox {
    border-color: ${getColor("primary", 0.3)} !important;
    width: 30px;
    height: 30px;
    --antd-wave-shadow-color: ${colors.teal} !important;

    > :after {
      transform: rotate(45deg) scale(1) translate(-10%, -80%) !important;
    }
    :hover,
    :active,
    :focus {
      border-color: ${colors.teal} !important;
      :after {
        opacity: 0.3;
        transform: rotate(0deg) scale(1) translate(0%, 0%) !important;
      }
    }
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background: ${colors.teal};
    border-color: ${colors.teal} !important;
  }

  .ant-checkbox-checked {
    :after {
      border-color: ${colors.teal} !important;
      background: ${colors.teal} !important;
    }
  }

  ${media.tablet`
    max-width: 400px;
  `}

  &:focus {
    border: 1px solid red;
  }
`

const FormItem = styled(Form.Item)`
  position: relative;
  ${media.largerPhone`
    max-width: 300px;
    margin: 0 auto;
  `}

  .ant-form-explain {
    font-family: GT America, sans-serif;
    font-weight: 600;
    position: absolute !important;
    bottom: -20px !important;
  }
`

const CheckboxText = styled.div`
  font-family: GT America, sans-serif;
  display: inline;
  font-size: 16px;
`

const TabbableWrapper = styled.div`
  font-family: GT America, sans-serif;
  font-size: 16px;
  line-height: 20px;

  &:focus {
    outline: none !important;
  }
`

const Files = styled.div`
  font-family: GT America, sans-serif;
  margin-left: 38px;
  position: relative;

  div > a,
  div {
    color: ${colors.teal} !important;
    line-height: 22px;

    &:hover {
      font-weight: 600;
    }

    &:active {
      font-weight: 400;
    }
  }
`

export default class CheckboxQuestionType extends React.Component {
  state = {
    isValid: null,
  }

  componentDidMount() {
    try {
      this.props.focus && this.input && this.input.focus()
    } catch (err) {}
  }

  render() {
    const { question, getFieldDecorator } = this.props
    return (
      <div>
        <Question {...question} focus={this.props.focus} />
        {getFieldDecorator && (
          <FormItem>
            {getFieldDecorator(question.identifier, {
              initialValue: this.props.value || false,
              validateFirst: true,
              // Remove points and commas
              rules: [
                {
                  validator: (rule, isChecked, callback) => {
                    if (this.props.checkRequired && !isChecked) {
                      callback(false)
                    } else {
                      callback()
                    }
                  },
                  message: "Bitte zustimmen",
                },
                {
                  required: this.props.question.required,
                  message: "Bitte ausfüllen",
                },
              ],
              trigger: "valueChanged",
              valuePropName: "checked",
            })(
              <InputFieldWrapper
                placeholder={this.props.placeholder}
                onPressEnter={event => {
                  event.preventDefault()
                  this.props.onSubmit(this.props.question.identifier)
                }}
                innerRef={inputField => {
                  this.input = inputField
                }}
                prefix={<TextIcon>#</TextIcon>}
                suffix={
                  this.state.isValid != null ? (
                    this.state.isValid ? (
                      <CheckIcon />
                    ) : (
                      <ErrorIcon />
                    )
                  ) : (
                    <span />
                  )
                }
                onChange={this.onValueChange}
              >
                <CheckboxText>{this.props.text}</CheckboxText>
              </InputFieldWrapper>
            )}
            <Files>
              {this.props.links.map(({ name, url, file }) => {
                let fileUrl = get(file, "file.asset.url", url)
                return (
                  <div key={`${question.identifier}-checkboxList-${name}`}>
                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                      {name}
                    </a>
                  </div>
                )
              })}
            </Files>
          </FormItem>
        )}
      </div>
    )
  }
}

class InputFieldWrapper extends React.Component {
  render() {
    const { innerRef, ...rest } = this.props
    let errorInfo = {}

    if (this.props["data-__field"].errors) {
      errorInfo = {
        suffix: <ErrorIcon />,
      }
    }
    return (
      <TabbableWrapper
        tabIndex="0"
        onKeyDown={event => {
          if (event.keyCode === 13) {
            this.props.valueChanged(!this.props.checked)
          }
        }}
      >
        <CheckboxInput
          tabIndex="-1"
          {...rest}
          onChange={this.props.valueChanged}
          ref={input => innerRef(input)}
          {...errorInfo}
        >
          {this.props.children}
        </CheckboxInput>
      </TabbableWrapper>
    )
  }
}
